import { useMemo } from "react";
import { Flex, Text, Kbd, Button } from "@radix-ui/themes";
import { DropdownMenu } from "@/components/shared/dropdown-menu";
import { StructureCheck } from "@/v2/assets/icons/StructureCheck";
import { AiFolderIcon } from "@/v2/assets/icons/AiFolderIcon";
import { DashboardSquareIcon } from "@/v2/assets/icons/DashboardSquareIcon";

interface SimulatorActionsButtonProps {
  onCreateSnippetClick?: () => void;
  onRegenerateClick: () => void;
  onAddToRegressionSet?: () => void;
}

export function SimulatorActionsButton({
  onCreateSnippetClick,
  onRegenerateClick,
  onAddToRegressionSet,
}: SimulatorActionsButtonProps) {
  const menuItems = useMemo(
    () => [
      {
        label: (
          <Flex
            align="center"
            justify="between"
            gap="4"
            style={{ width: "100%" }}
          >
            <Text size="2">Create Snippet</Text>
            <Kbd
              size="1"
              style={{
                fontSize: "10px",
                backgroundColor: "var(--gray-3)",
                padding: "2px 6px",
                minWidth: "auto",
                height: "auto",
                lineHeight: "1.2",
              }}
            >
              {navigator.platform.includes("Mac") ? "⌘" : "Ctrl"}+M
            </Kbd>
          </Flex>
        ),
        onClick: () => {
          onCreateSnippetClick?.();
        },
        icon: <AiFolderIcon size={14} fill="gray" />,
      },
      {
        label: (
          <Flex
            align="center"
            justify="between"
            gap="4"
            style={{ width: "100%" }}
          >
            <Text size="2">Regenerate</Text>
            <Kbd
              size="1"
              style={{
                fontSize: "10px",
                backgroundColor: "var(--gray-3)",
                padding: "2px 6px",
                minWidth: "auto",
                height: "auto",
                lineHeight: "1.2",
              }}
            >
              R
            </Kbd>
          </Flex>
        ),
        onClick: onRegenerateClick,
      },
      {
        label: (
          <Flex align="center" gap="4" style={{ width: "100%" }}>
            <Text size="2">Add to Regression Set</Text>
          </Flex>
        ),
        onClick: () => onAddToRegressionSet?.(),
        icon: <StructureCheck size={14} fill="gray" />,
      },
    ],
    [onCreateSnippetClick, onRegenerateClick, onAddToRegressionSet]
  );

  return (
    <DropdownMenu items={menuItems}>
      <DropdownMenu.Trigger>
        <Button
          type="button"
          color="gray"
          variant="ghost"
          highContrast
          size="1"
        >
          <DashboardSquareIcon size={12} fill="currentColor" />
          <Text size="1">Actions</Text>
        </Button>
      </DropdownMenu.Trigger>
    </DropdownMenu>
  );
}

